import Icon from '@/components/ui/AppIcon';

interface BookingSummaryProps {
  consultationType: string;
  counselorName: string;
  date: string;
  time: string;
  duration: string;
  price: string;
}

export default function BookingSummary({
  consultationType,
  counselorName,
  date,
  time,
  duration,
  price
}: BookingSummaryProps) {
  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 border border-border rounded-xl p-6">
      <h3 className="text-lg font-bold text-foreground mb-4">Booking Summary</h3>
      <div className="space-y-4">
        <div className="flex items-start space-x-3">
          <Icon name="ClipboardDocumentListIcon" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-xs text-muted-foreground">Consultation Type</p>
            <p className="text-sm font-semibold text-foreground">{consultationType}</p>
          </div>
        </div>
        <div className="flex items-start space-x-3">
          <Icon name="UserIcon" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-xs text-muted-foreground">Counselor</p>
            <p className="text-sm font-semibold text-foreground">{counselorName}</p>
          </div>
        </div>
        <div className="flex items-start space-x-3">
          <Icon name="CalendarIcon" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-xs text-muted-foreground">Date</p>
            <p className="text-sm font-semibold text-foreground">{date}</p>
          </div>
        </div>
        <div className="flex items-start space-x-3">
          <Icon name="ClockIcon" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-xs text-muted-foreground">Time</p>
            <p className="text-sm font-semibold text-foreground">{time}</p>
          </div>
        </div>
        <div className="flex items-start space-x-3">
          <Icon name="ClockIcon" size={20} className="text-primary flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-xs text-muted-foreground">Duration</p>
            <p className="text-sm font-semibold text-foreground">{duration}</p>
          </div>
        </div>
        <div className="pt-4 border-t border-border">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Total</span>
            <span className="text-2xl font-bold text-primary">{price}</span>
          </div>
        </div>
      </div>
    </div>
  );
}